export const LOCALES = ["ja", "en"] as const;
export const SOURCE_LOCALE = "en" as const;

const rawLocales = Array.from(LOCALES);

const SUPPORTED_LOCALES = new Set<string>(rawLocales);
export const DEFAULT_LOCALE = SUPPORTED_LOCALES.has(SOURCE_LOCALE)
  ? SOURCE_LOCALE
  : (rawLocales[0] ?? "en");

export type SupportedLocale = (typeof LOCALES)[number];

/**
 * 指定した言語コードがサポート対象かどうかを判定します。
 *
 * @param locale 判定したい言語コード。
 */
export const isSupportedLocale = (
  locale: string | null | undefined,
): locale is SupportedLocale => !!locale && SUPPORTED_LOCALES.has(locale);
